import { IdpRole } from '../constant';

export type Config = {
  id: number;
  locations: ConfigLocation[];
  roles?: ConfigRole[];
  adv_body: AdvBody;
  dates?: ConfigDate;
};

export type AdvBody = {
  image_url: string;
  image_url_mobile: string;
  title: string;
  main_text: string;
  ctas: Cta[];
};

export type Cta = {
  text: string;
  url: string;
};

export type ConfigLocation = {
  host: string;
  paths: string[];
};

export type ConfigRole = {
  role: IdpRole;
  teaching_groups?: string[];
};

export type ConfigDate = {
  start_date: string;
  end_date: string;
};

export type UserRoles = {
  roleName: IdpRole;
};

export type MyzUser = {
  id: number;
};

export type User = {
  id: number;
  roles: UserRoles[];
  teachingGroupsCodes?: string[];
  myz: MyzUser;
};

export interface idpLoginUserInfo extends HTMLElement {
  getUserInfo: () => Promise<idpCompletePayload>;
}

export interface idpCompletePayload {
  e: User;
  teachingGroups: { code: string }[];
}
